module.exports = __webpack_public_path__ + "img/femme-enceinte.0051c8ff.jpg";